import type { Address } from 'viem';

import type { AdjacentRound } from '../../../../../../../model/AdjacentRound/adjacentRound';
import { getParticipationInfo } from '../../../../../../../model/AdjacentRound/roundParticipation';
import {
  getPredictionRoundResult,
  PredictionRoundState,
} from '../../../../../../../model/AdjacentRound/roundState';
import { PredictionDirection } from '../../../../../../../model/PredictionDirection';
import { RoundResult } from '../../../../../../../model/RoundResult';

type CalculateOptionsStateProps = {
  round: AdjacentRound;
  wallet?: Address;
};

export type PredictionOptionState = 'default' | 'selected' | 'ended' | 'disabled';

export type CalculateOptionsStateResult = Record<PredictionDirection, PredictionOptionState>;

export const calculatePredictionOptionState = ({
  round,
  wallet,
}: CalculateOptionsStateProps): CalculateOptionsStateResult => {
  const participation = getParticipationInfo({ round, wallet });
  const roundResult = getPredictionRoundResult(round);

  switch (round.state) {
    case PredictionRoundState.CLOSED:
      return {
        UP: roundResult === RoundResult.UP ? 'ended' : 'disabled',
        DOWN: roundResult === RoundResult.DOWN ? 'ended' : 'disabled',
      };
    case PredictionRoundState.LOCKED:
    case PredictionRoundState.ACTIVE:
      return {
        UP:
          participation.isParticipated && participation.direction === PredictionDirection.UP
            ? 'selected'
            : 'default',
        DOWN:
          participation.isParticipated && participation.direction === PredictionDirection.DOWN
            ? 'selected'
            : 'default',
      };
  }
};
